import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import React from 'react';
import { useDocumentLibraryStorage } from '../hooks';
export const DocumentLibraryContext = React.createContext({
    handleCurrentDirectoryId: () => undefined,
    reloadParents: () => undefined,
});
export const DocumentLibraryContextProvider = ({ children }) => {
    const [currentDirectoryId, setCurrentDirectoryId] = React.useState();
    const [parents, setParents] = React.useState();
    const [parentPermissions, setParentPermissions] = React.useState([]);
    const currentParentPermission = parentPermissions.length > 0 ? parentPermissions[parentPermissions.length - 1] : undefined;
    const storage = useDocumentLibraryStorage();
    const fetchParents = React.useCallback(() => {
        if (currentDirectoryId) {
            storage
                .listFileParents({ id: currentDirectoryId, includeSelf: true })
                .then((listResponse) => {
                setParents(listResponse.rows);
                setParentPermissions(listResponse.rows.map((parentDirectory) => parentDirectory.permissions));
            })
                .catch(handleErrorSnackbar);
        }
        else {
            setParentPermissions([]);
            setParents(undefined);
        }
    }, [currentDirectoryId, storage]);
    React.useEffect(() => {
        fetchParents();
    }, [fetchParents, currentDirectoryId]);
    const handleCurrentDirectoryId = (directoryId) => {
        setCurrentDirectoryId(directoryId);
    };
    return (React.createElement(DocumentLibraryContext.Provider, { value: {
            handleCurrentDirectoryId,
            currentDirectoryId: currentDirectoryId,
            currentParentPermission,
            parents,
            reloadParents: () => fetchParents(),
        } }, children));
};
